import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION15: PdfComponent = {
  type: 'section',
  id: 's15',
  title: '15. Confidential Information',
  content: [
    {
      type: 'bulletList',
      id: 's15bullets',
      bulletType: 'number',
      content: [
        {
          copy: "Each party agrees that it shall keep any Confidential Information of the other party confidential and shall not use or disclose the other party's Confidential Information to any person, except as permitted by clause 15.2.",
        },
        {
          copy: 'Each party may:',
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: "disclose the other party's Confidential Information to those of its employees, officers, advisers, agents or representatives who need to know the relevant Confidential Information for the purposes of the performance of any obligations under this Agreement, provided that party ensures that each such recipient is aware of its confidential nature and agrees to comply with this clause as if it were a party;",
              },
              {
                copy: "disclose the other party's Confidential Information as may be required by law, any court, any governmental, regulatory or supervisory authority (including any securities exchange) or any other authority of competent jurisdiction; and",
              },
              {
                copy: "use the other party's Confidential Information only to perform its obligations under this Agreement.",
              },
            ],
          },
        },
        {
          copy: 'Each party recognises that any breach or threatened breach of this clause 15 may cause irreparable harm to the other party and/or any of its Affiliates for which damages may not be an adequate remedy. Accordingly, in addition to any other remedies and damages a party may have, each party agrees that the other party may be entitled to the remedies of specific performance, injunction and other equitable relief without proof of special damages.',
        },
        {
          copy: 'This clause 15 shall bind the parties during the Term and following the termination or expiry of this Agreement.',
        },
      ],
      prefix: '15',
    },
  ],
};
